import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./FormAddOdberatel.scss";

// prop types
import userPropTypes from "../../../propTypes/userPropTypes";

// actions
import * as appHeaderActions from "../../../actions/appHeaderActions";
import * as loginActions from "../../../actions/loginActions";
import * as userActions from "../../../actions/userActions";

//components
import withRouter from "../../../coraWebComponents/utils/withRouter";
import Button from "../../../coraWebComponents/buttons/Button";
import Input from "../../../coraWebComponents/forms/Input";
import Tooltip from "../../../coraWebComponents/forms/Tooltip";
import LoadingPanel from "../../../coraWebComponents/LoadingPanel";

// Routes
import Routes from "../../../constants/Routes";

class FormAddOdberatel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menoOdberatela: "",
      diskretnyUdaj: "",
    };
  }

  // FORM METHODS
  handleOnChange = (name, value) => {
    this.setState({ [name]: value });
  };
  onSubmitHandle = async (event) => {
    event.preventDefault();
    const { addOdberatel, refreshUser, navigate } = this.props;
    await addOdberatel({ ...this.state });

    navigate(Routes.HOME);

    await refreshUser();
    await this.getListOdberatelHeaderHandle();
  };

  // METHODS
  buildFilters = (value) => {
    return [
      {
        field: "I_ORGAN",
        operator: "in",
        value,
      },
    ];
  };
  getListOdberatelHeaderHandle = async () => {
    const { getListOdberatelHeader, user } = this.props;

    // GET ORGANS LIST
    const filters = this.buildFilters(user.Uzivatel.I_ORGANS.join());
    await getListOdberatelHeader({ logic: "and", filters });
  };

  // SYSTEM METHODS
  componentDidMount() {
    const { showAppHeader, changeHeaderTitle } = this.props;

    showAppHeader(false);
    changeHeaderTitle("");
  }
  render() {
    const { menoOdberatela, diskretnyUdaj, disabled } = this.state;
    const { user, isLoading } = this.props;

    const media = window.matchMedia('only screen and (min-width: 768px)');
    const className = media ? "col-6 offset-3 p-0 forWeb" : "col p-0 forMobile";

    return (
      <div className="row m-0">
        <div className={className}>
          <div className="card formular">
            <div className="form-body">
              {/* FORM */}
              <Tooltip>
                <form
                  className="k-form addOdberatel"
                  onSubmit={this.onSubmitHandle}
                >
                  {/* TITLE */}
                  <div className="card-title">
                    <div>Pridať ďalšieho odberateľa</div>
                  </div>

                  {/* SUBTITLES */}
                  {user && (
                    <div className="card-subtitle">
                      <div className="row m-0">
                        <div className="col-6 label">Email:</div>
                        <div className="col-6 value">{user.Uzivatel.N_UZ}</div>
                      </div>
                      <div className="row m-0">
                        <div className="col-6 label">Telefónny kontakt:</div>
                        <div className="col-6 value">
                          {user.Uzivatel.MOBIL || "nezadaný"}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* FIELDS */}
                  <p>&nbsp;</p>
                  <div className="k-form-field">
                    <span>{"*Meno odberateľa"}</span>
                    <Input
                      title="Vložte meno odberateľa, ktorého údaje chcete vidieť.
                      Musí byť zapísané presne v takom tvare, ako je zobrazené na Vašej faktúre, 
                      napr. ‘Mrkvička Jozef, MUDr.‘"
                      type="text"
                      name="menoOdberatela"
                      onChange={this.handleOnChange}
                      value={menoOdberatela}
                      disabled={isLoading || disabled}
                      required
                    />
                  </div>
                  <div className="k-form-field">
                    <span>{"*Diskrétny údaj"}</span>
                    <Input
                      title="Vložte číslo faktúry, ktorým je označená ľubovolná faktúra, 
                      ktorá Vám bola doručená pre Vami zadaného odberateľa."
                      type="text"
                      name="diskretnyUdaj"
                      onChange={this.handleOnChange}
                      value={diskretnyUdaj}
                      disabled={isLoading || disabled}
                      required
                    />
                  </div>

                  {/* SUBMIT BUTTON */}
                  <div className="k-form-field">
                    <Button
                      primary={true}
                      disabled={isLoading || disabled}
                      label="Pridať"
                      type="submit"
                    />
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
        <LoadingPanel isLoading={isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.user.isLoading || state.headerListOdberatel.isLoading,
    user: state.user.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  addOdberatel: async (data) => await dispatch(userActions.addOdberatel(data)),
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  getListOdberatelHeader: async (filter) => {
    await dispatch(
      appHeaderActions.getListOdberatelHeader(filter, [], { skip: 0, take: 20 })
    );
  },
  refreshUser: async () => await dispatch(loginActions.refreshUser()),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

FormAddOdberatel.propTypes = {
  addOdberatel: PropTypes.func,
  changeHeaderTitle: PropTypes.func,
  isLoading: PropTypes.bool,
  getListOdberatelHeader: PropTypes.func,
  refreshUser: PropTypes.func,
  showAppHeader: PropTypes.func,
  user: userPropTypes.user,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FormAddOdberatel)
);
